export const IconEyeOff = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 24 24"
        >
            {props?.defs ? props.defs : null}
            <path
                style={{fill: props?.iconFill}}
                fillRule="nonzero"
                d="M17.069 6.546l2.684-2.359A.753.753 0 0121 4.75a.748.748 0 01-.254.562l-16.5 14.501a.748.748 0 11-.993-1.125l2.438-2.143c-1.414-1.132-2.627-2.552-3.547-4.028a1 1 0 01.001-1.034C4.256 8.093 7.92 5 11.998 5c1.815 0 3.536.593 5.071 1.546zm2.319 1.83a16.03 16.03 0 012.474 3.117 1 1 0 010 1.014C19.794 15.91 16.141 19 11.998 19c-1.297 0-2.553-.313-3.729-.849l1.247-1.096a7.33 7.33 0 002.482.445c3.516 0 6.576-2.622 8.413-5.5a14.643 14.643 0 00-2.145-2.637zm-3.434 3.019a4.001 4.001 0 01-5.061 4.449l1.58-1.389a2.503 2.503 0 001.901-1.671zm-.058-3.818c-1.197-.67-2.512-1.077-3.898-1.077-3.465 0-6.533 2.632-8.404 5.5.853 1.308 1.955 2.567 3.231 3.549l1.728-1.519a4.001 4.001 0 015.902-5.187zm-2.6 2.285a2.5 2.5 0 00-3.583 3.149z"
            ></path>
        </svg>
    )
};

export default IconEyeOff;
